import { useEffect, useRef, useState } from 'react';
import { Input } from '@sara/ui/components/input';
import type { FilterEditorProps } from '../types';

export function ExternalUserIdEditor({ search, onChange }: FilterEditorProps) {
  const [local, setLocal] = useState(search.externalUserIdSearch ?? '');
  const debounceRef = useRef<ReturnType<typeof setTimeout>>(undefined);
  // Resets `local` to the external value when it changes. Adjusted during render
  // (React's own pattern for this) rather than in an effect, which would render
  // once with the stale `local` before catching up a frame later.
  const [prevExternalValue, setPrevExternalValue] = useState(search.externalUserIdSearch);
  if (search.externalUserIdSearch !== prevExternalValue) {
    setPrevExternalValue(search.externalUserIdSearch);
    setLocal(search.externalUserIdSearch ?? '');
  }

  useEffect(() => () => clearTimeout(debounceRef.current), []);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const next = e.target.value;
    setLocal(next);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      onChange({ externalUserIdSearch: next.trim() || undefined });
    }, 300);
  }

  return (
    <Input
      placeholder="Filter by external user ID"
      value={local}
      onChange={handleChange}
      className="h-9 text-[13.5px]"
    />
  );
}
